import { Api } from "./Api";

export default {
  async get(type, params, headers = {
    Accept: "application/json"
  }) {
    return await Api.get(`v1/drips/${type}/get` + params, {
      headers: headers
    });
  },
  // getStatus(domain_id, group_id) {
  //   return Api.get(`/v1/drips/welcome/getStatus/` + domain_id + '/' + group_id);
  // },
  deleteInitial(id) {
    return Api.delete(`/v1/drips/` + id);
  },
  delete(type, group_id, id) {
    return Api.delete(`/v1/drips/${type}/delete/` + group_id + '/' + id);
  },
  deleteGroup(type, group_id) {
    return Api.delete(`/v1/drips/${type}/delete/` + group_id);
  },

  search(type, params = "") {
    return Api.delete(`/v1/drips/${type}/search` + params);
  },
  // deleteRecurring(type, group_id, id) {
  //   return Api.delete(`/v1/drips/${type}/delete/` + group_id + '/' + id);
  // },
  deleteArray(formData) {
    return Api.post(`/v1/drips/deleteArray/`, formData, {
      "Content-Type": "multipart/form-data"
    });
  },
  updateGroupSchedule(type, domainId, welcomeGroupId, obj) {
    return Api.post(`/v1/drips/${type}/updateScheduleByGroup/${domainId}/${welcomeGroupId}`, obj);
  },
  createOrUpdate(type, json, withReplaceUrlButtons = false, client_uid = null) {
    let headers = client_uid ? {
      Accept: "application/json",
      client: client_uid,
      withReplaceUrlButtons: withReplaceUrlButtons
    }
      : {
        Accept: "application/json",
        withReplaceUrlButtons: withReplaceUrlButtons
      }

    return Api.post(`/v1/drips/${type}/createOrUpdate`, json, {
      headers: headers
    });
  },
  createOrUpdateClient(type, json, client_uid, withReplaceUrlButtons = false) {
    return Api.post(`/v1/drips/${type}/createOrUpdate`, json, {
      headers: {
        Accept: "application/json",
        client: client_uid,
        withReplaceUrlButtons: withReplaceUrlButtons
      }
    });
  },

  // type, domain_id, group_id, status
  updateStatus(data) {
    return Api.post(`/v1/drips/${data.type}/updateStatus/` + data.domain_id + '/' + data.group_id + '/' + data.status);
  },
  updateDrip(type, group_id, id, params, json) {
    return Api.post(`/v1/drips/${type}/createOrUpdate` + group_id + "/" + id + params, json);
  },
  update(id, json) {
    return Api.put(`/v1/drips/${id}`, json);
  },
  store(json, headers = {}) {
    return Api.post(`/v1/drips`, json, {
      headers: headers
    });
  },
  getRecurringDripsByGroupId(params) {
    return Api.get(`/v1/drips/recurring/get${params}`)
  },
  getRecurringGroupIds(domainId) {
    return Api.get(`/v1/abstract/groups/by-domain?domain_id=${domainId}`)
  },
  storeGroup(payload) {
    return Api.post(`/v1/abstract/groups`, payload)
  },
  attachRecurringToGroup(groupId, payload) {
    return Api.post(`/v1/abstract/groups/${groupId}/attach`, payload)
  },
  detachRecurringFromGroup(groupId, payload) {
    return Api.post(`/v1/abstract/groups/${groupId}/detach`, payload)
  },
  deleteRecurringGroup(groupId) {
    return Api.delete(`/v1/abstract/groups/${groupId}`)
  },
  toggleRecurringGroup(groupId, payload) {
    return Api.post(`/v1/abstract/groups/${groupId}/toggle?mode=multiple`, payload)
  },
  updateRecurringGroupSchedules(params) {
    return Api.post(`/v1/tools/update-schedules/recurring${params}`)
  }
};
